<template>
  <div>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <UserEditor
      :isShow="isEditorShow"
      :user="selectedItem"
      @close="isEditorShow = false"
    ></UserEditor>
    <v-breadcrumbs
      :items="breadcrumbs"
      large
      style="padding-bottom: 0px"
    ></v-breadcrumbs>
    <v-data-table
      style="width: 96%; margin-left: 2%"
      :headers="headers"
      :items="userList"
      :loading="isTableLoading"
      item-key="identity"
      :search="search"
      :options.sync="options"
      :server-items-length="totalItems"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Manage Users</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            class="mt-3"
            label="SEARCH"
            v-model="search"
            @change="getUsers"
          ></v-text-field>
          <v-spacer></v-spacer>
          <!--<v-btn class="mr-2" color="primary" @click="openUploadModal">
            <v-icon class="mr-2">mdi-upload</v-icon>Create</v-btn
          >-->
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon @click="showDetails(item)">mdi-account-details-outline</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { userService } from "@/api/user-service";
import UserEditor from "@/components/Modals/UserEditor";
import { mapGetters } from "vuex";

export default {
  name: "ManageUser",
  components: { UserEditor },
  computed: {
    ...mapGetters(["groupList"]),
  },
  data: () => {
    return {
      isLoading: false,
      isTableLoading: false,
      isEditorShow: false,
      selectedItem: { hostKey: "", name: "" },
      search: "",
      userList: [],
      totalItems: 0,
      options: {},
      headers: [
        { text: "HostKey", value: "hostKey", width: "5%" },
        { text: "Name", value: "name", width: "25%" },
        { text: "Email", value: "email", width: "10%", sortable: false },
        { text: "Role", value: "departments", width: "30%", sortable: false },
        { text: "Actions", value: "actions", width: "5%", sortable: false },
      ],
      breadcrumbs: [
        {
          text: "< Home",
          href: "",
          disabled: false,
          href: "/",
        },
        {
          text: "Users",
          href: "",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    capitalizeFirstLetter(str) {
      if (str == "") return "";
      const capitalized = str[0].charAt(0).toUpperCase() + str[0].slice(1);
      return capitalized;
    },
    async init() {
      this.isLoading = true;
      this.userList = await userService.getUser(1, 10, "", "", "").result;
      this.isLoading = false;
    },
    async getUsers() {
      this.userList = [];
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.isTableLoading = true;
      let response = await userService.getUser(
        page,
        itemsPerPage,
        this.capitalizeFirstLetter(sortBy),
        sortDesc,
        this.search
      );
      if (response.total > 0) {
        this.totalItems = response.total;
        this.userList = response.result;
      }
      this.isTableLoading = false;
    },
    showDetails(item) {
      this.selectedItem = item;
      this.isEditorShow = true;
    },
  },
  watch: {
    search(val) {
      //this.init();
    },
    options: {
      handler() {
        this.getUsers();
      },
      deep: true,
    },
  },
  async mounted() {
    //console.log('loading')
    if (this.groupList) await this.$store.dispatch("getGroupList");
    //this.init();
  },
};
</script>

<style>
</style>